// extracted by mini-css-extract-plugin
module.exports = {"card":"MyScrollableList_card__vZIqf","card-menu":"MyScrollableList_card-menu__3x5oI","listArea":"MyScrollableList_listArea__1Ygme","item":"MyScrollableList_item__2JC0w"};